<app-import-nav />

<h5 class="mt-3">Import Orphan Exemptions</h5>

@if (hasError) {
  <div class="alert alert-danger">
    There was a problem uploading the file.
    <ul class="mt-2">
      @for (error of errors; track error) {
        <li>{{ error }}</li>
      }
    </ul>
  </div>
}

<app-icc-import-upload
  (uploadComplete)="onUploadComplete($event)"
  (uploadStart)="onUploadStart()"
  />

<div class="mt-3 border p-3 rounded">
  <strong>File Requirements</strong>
  <ol class="mx-3 ps-2">
    <li class="py-2">
      Possible fields
      <ul class="ps-2">
        <li><code>ndc</code> <span>(required, 11 digit)</span></li>
        <li><code>drug_description</code></li>
        <li><code>exemption_effective_date</code> <span>(required, date, format MM/DD/YYYY)</span></li>
        <li><code>exemption_term_date</code> <span>(date, format MM/DD/YYYY)</span></li>
      </ul>
    </li>
    <li class="py-2">
      Example file
      <div>
        <small><strong>NOTE:</strong> Extra columns will be ignored and column headers are case insensitive.</small>
      </div>
      <div class="bg-light p-2 border w-100">
        <small>
          <strong>
            <code class="csv-header">
              ndc,drug_description,exemption_effective_date,exemption_term_date
            </code>
          </strong>
          <br />
          <code>51645-703-01,Acetaminophen,10/10/2020,12/31/2022</code><br />
          <code>51645070305,,02/20/2020,</code><br />
        </small>
      </div>
    </li>
    <li class="py-2"><code>.csv</code> only</li>
  </ol>
</div>
